webpackJsonp([26],{

/***/ 1127:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 415,
	"./af.js": 415,
	"./ar": 423,
	"./ar-dz": 416,
	"./ar-dz.js": 416,
	"./ar-kw": 417,
	"./ar-kw.js": 417,
	"./ar-ly": 418,
	"./ar-ly.js": 418,
	"./ar-ma": 419,
	"./ar-ma.js": 419,
	"./ar-ps": 420,
	"./ar-ps.js": 420,
	"./ar-sa": 421,
	"./ar-sa.js": 421,
	"./ar-tn": 422,
	"./ar-tn.js": 422,
	"./ar.js": 423,
	"./az": 424,
	"./az.js": 424,
	"./be": 425,
	"./be.js": 425,
	"./bg": 426,
	"./bg.js": 426,
	"./bm": 427,
	"./bm.js": 427,
	"./bn": 429,
	"./bn-bd": 428,
	"./bn-bd.js": 428,
	"./bn.js": 429,
	"./bo": 430,
	"./bo.js": 430,
	"./br": 431,
	"./br.js": 431,
	"./bs": 432,
	"./bs.js": 432,
	"./ca": 433,
	"./ca.js": 433,
	"./cs": 434,
	"./cs.js": 434,
	"./cv": 435,
	"./cv.js": 435,
	"./cy": 436,
	"./cy.js": 436,
	"./da": 437,
	"./da.js": 437,
	"./de": 440,
	"./de-at": 438,
	"./de-at.js": 438,
	"./de-ch": 439,
	"./de-ch.js": 439,
	"./de.js": 440,
	"./dv": 441,
	"./dv.js": 441,
	"./el": 442,
	"./el.js": 442,
	"./en-au": 443,
	"./en-au.js": 443,
	"./en-ca": 444,
	"./en-ca.js": 444,
	"./en-gb": 445,
	"./en-gb.js": 445,
	"./en-ie": 446,
	"./en-ie.js": 446,
	"./en-il": 447,
	"./en-il.js": 447,
	"./en-in": 448,
	"./en-in.js": 448,
	"./en-nz": 449,
	"./en-nz.js": 449,
	"./en-sg": 450,
	"./en-sg.js": 450,
	"./eo": 451,
	"./eo.js": 451,
	"./es": 455,
	"./es-do": 452,
	"./es-do.js": 452,
	"./es-mx": 453,
	"./es-mx.js": 453,
	"./es-us": 454,
	"./es-us.js": 454,
	"./es.js": 455,
	"./et": 456,
	"./et.js": 456,
	"./eu": 457,
	"./eu.js": 457,
	"./fa": 458,
	"./fa.js": 458,
	"./fi": 459,
	"./fi.js": 459,
	"./fil": 460,
	"./fil.js": 460,
	"./fo": 461,
	"./fo.js": 461,
	"./fr": 464,
	"./fr-ca": 462,
	"./fr-ca.js": 462,
	"./fr-ch": 463,
	"./fr-ch.js": 463,
	"./fr.js": 464,
	"./fy": 465,
	"./fy.js": 465,
	"./ga": 466,
	"./ga.js": 466,
	"./gd": 467,
	"./gd.js": 467,
	"./gl": 468,
	"./gl.js": 468,
	"./gom-deva": 469,
	"./gom-deva.js": 469,
	"./gom-latn": 470,
	"./gom-latn.js": 470,
	"./gu": 471,
	"./gu.js": 471,
	"./he": 472,
	"./he.js": 472,
	"./hi": 473,
	"./hi.js": 473,
	"./hr": 474,
	"./hr.js": 474,
	"./hu": 475,
	"./hu.js": 475,
	"./hy-am": 476,
	"./hy-am.js": 476,
	"./id": 477,
	"./id.js": 477,
	"./is": 478,
	"./is.js": 478,
	"./it": 480,
	"./it-ch": 479,
	"./it-ch.js": 479,
	"./it.js": 480,
	"./ja": 481,
	"./ja.js": 481,
	"./jv": 482,
	"./jv.js": 482,
	"./ka": 483,
	"./ka.js": 483,
	"./kk": 484,
	"./kk.js": 484,
	"./km": 485,
	"./km.js": 485,
	"./kn": 486,
	"./kn.js": 486,
	"./ko": 487,
	"./ko.js": 487,
	"./ku": 489,
	"./ku-kmr": 488,
	"./ku-kmr.js": 488,
	"./ku.js": 489,
	"./ky": 490,
	"./ky.js": 490,
	"./lb": 491,
	"./lb.js": 491,
	"./lo": 492,
	"./lo.js": 492,
	"./lt": 493,
	"./lt.js": 493,
	"./lv": 494,
	"./lv.js": 494,
	"./me": 495,
	"./me.js": 495,
	"./mi": 496,
	"./mi.js": 496,
	"./mk": 497,
	"./mk.js": 497,
	"./ml": 498,
	"./ml.js": 498,
	"./mn": 499,
	"./mn.js": 499,
	"./mr": 500,
	"./mr.js": 500,
	"./ms": 502,
	"./ms-my": 501,
	"./ms-my.js": 501,
	"./ms.js": 502,
	"./mt": 503,
	"./mt.js": 503,
	"./my": 504,
	"./my.js": 504,
	"./nb": 505,
	"./nb.js": 505,
	"./ne": 506,
	"./ne.js": 506,
	"./nl": 508,
	"./nl-be": 507,
	"./nl-be.js": 507,
	"./nl.js": 508,
	"./nn": 509,
	"./nn.js": 509,
	"./oc-lnc": 510,
	"./oc-lnc.js": 510,
	"./pa-in": 511,
	"./pa-in.js": 511,
	"./pl": 512,
	"./pl.js": 512,
	"./pt": 514,
	"./pt-br": 513,
	"./pt-br.js": 513,
	"./pt.js": 514,
	"./ro": 515,
	"./ro.js": 515,
	"./ru": 516,
	"./ru.js": 516,
	"./sd": 517,
	"./sd.js": 517,
	"./se": 518,
	"./se.js": 518,
	"./si": 519,
	"./si.js": 519,
	"./sk": 520,
	"./sk.js": 520,
	"./sl": 521,
	"./sl.js": 521,
	"./sq": 522,
	"./sq.js": 522,
	"./sr": 524,
	"./sr-cyrl": 523,
	"./sr-cyrl.js": 523,
	"./sr.js": 524,
	"./ss": 525,
	"./ss.js": 525,
	"./sv": 526,
	"./sv.js": 526,
	"./sw": 527,
	"./sw.js": 527,
	"./ta": 528,
	"./ta.js": 528,
	"./te": 529,
	"./te.js": 529,
	"./tet": 530,
	"./tet.js": 530,
	"./tg": 531,
	"./tg.js": 531,
	"./th": 532,
	"./th.js": 532,
	"./tk": 533,
	"./tk.js": 533,
	"./tl-ph": 534,
	"./tl-ph.js": 534,
	"./tlh": 535,
	"./tlh.js": 535,
	"./tr": 536,
	"./tr.js": 536,
	"./tzl": 537,
	"./tzl.js": 537,
	"./tzm": 539,
	"./tzm-latn": 538,
	"./tzm-latn.js": 538,
	"./tzm.js": 539,
	"./ug-cn": 540,
	"./ug-cn.js": 540,
	"./uk": 541,
	"./uk.js": 541,
	"./ur": 542,
	"./ur.js": 542,
	"./uz": 544,
	"./uz-latn": 543,
	"./uz-latn.js": 543,
	"./uz.js": 544,
	"./vi": 545,
	"./vi.js": 545,
	"./x-pseudo": 546,
	"./x-pseudo.js": 546,
	"./yo": 547,
	"./yo.js": 547,
	"./zh-cn": 548,
	"./zh-cn.js": 548,
	"./zh-hk": 549,
	"./zh-hk.js": 549,
	"./zh-mo": 550,
	"./zh-mo.js": 550,
	"./zh-tw": 551,
	"./zh-tw.js": 551
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1131;

/***/ }),

/***/ 1143:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_LOGINUSER = exports.SET_LOGINUSER = 'SET_LOGINUSER';
var REMOVE_LOGINUSER = exports.REMOVE_LOGINUSER = 'REMOVE_LOGINUSER';

var SET_ADMIN = exports.SET_ADMIN = 'SET_ADMIN';
var REMOVE_ADMIN = exports.REMOVE_ADMIN = 'REMOVE_ADMIN';

var SWITCH_COLLASPED = exports.SWITCH_COLLASPED = 'SWITCH_COLLASPED';
var SWITCH_CURRENT_MENU = exports.SWITCH_CURRENT_MENU = 'SWITCH_CURRENT_MENU';

var SWITCH_DRAWER = exports.SWITCH_DRAWER = 'SWITCH_DRAWER';

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeUserInfo = exports.setUserInfo = exports.getUserInfo = undefined;

var _stringify = __webpack_require__(77);

var _stringify2 = _interopRequireDefault(_stringify);

exports.getToken = getToken;
exports.setToken = setToken;
exports.removeToken = removeToken;

var _jsCookie = __webpack_require__(1130);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TokenKey = 'token';
var UserInfoKey = 'user-info';

function getToken() {
    return localStorage.getItem(TokenKey);
}

function setToken(token) {
    return localStorage.setItem(TokenKey, token);
}

function removeToken() {
    localStorage.removeItem(TokenKey);
    return _jsCookie2.default.remove(TokenKey);
}

var getUserInfo = exports.getUserInfo = function getUserInfo() {
    return _jsCookie2.default.get(UserInfoKey);
};

var setUserInfo = exports.setUserInfo = function setUserInfo(userInfo) {
    _jsCookie2.default.remove(UserInfoKey);
    localStorage.removeItem(UserInfoKey);
    localStorage.setItem(UserInfoKey, (0, _stringify2.default)(userInfo));
    return _jsCookie2.default.set(UserInfoKey, userInfo);
};

var removeUserInfo = exports.removeUserInfo = function removeUserInfo() {
    return _jsCookie2.default.remove(UserInfoKey);
};

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1144);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backend = function Backend() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1181));
};
var Front = function Front() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1182));
};

_vue2.default.use(_vueRouter2.default);

var routes = [{
    path: '/',
    redirect: '/epmc',
    component: Front,
    hidden: true,
    index: 0,
    children: [{
        path: 'login',
        component: function component() {
            return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1205));
        },
        name: 'login',
        meta: {
            title: '用户登陆',
            isBackend: false,
            mustAuth: false,
            showNav: false,
            hidden: true,
            index: 0
        }
    }, {
        path: "mind",
        component: function component() {
            return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1187));
        },
        name: 'mind',
        meta: {
            title: "个人首页",
            isBackend: false,
            mustAuth: true,
            showNav: true,
            hidden: true,
            index: 1
        }
    }, {
        path: 'epmc',
        component: function component() {
            return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1203));
        },
        name: 'epmc',
        meta: {
            title: '填写工时',
            isBackend: false,
            mustAuth: true,
            hiddenToolbar: false,
            showNav: true,
            hidden: true,
            index: 2
        }
    }, {
        path: 'changePwd',
        component: function component() {
            return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1202));
        },
        name: 'changePwd',
        meta: {
            title: '修改密码',
            isBackend: false,
            mustAuth: true,
            showNav: true,
            hidden: true,
            index: 3
        }
    }, {
        path: 'examineList',
        component: function component() {
            return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1184));
        },
        name: 'examineList',
        meta: {
            title: '全部工时审批',
            isBackend: false,
            mustAuth: true,
            hiddenToolbar: false,
            showNav: true,
            hidden: true,
            index: 4
        }
    }, {
        path: 'examine',
        component: function component() {
            return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1183));
        },
        name: 'examine',
        meta: {
            title: '当日工时审批',
            isBackend: false,
            mustAuth: true,
            hiddenToolbar: false,
            showNav: true,
            hidden: true,
            index: 5
        }
    }, {
        path: 'project',
        component: function component() {
            return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1186));
        },
        name: 'projectlist',
        meta: {
            title: '项目信息管理',
            isBackend: false,
            mustAuth: true,
            hiddenToolbar: false,
            showNav: true,
            hidden: true,
            index: 6
        }
    }, {
        path: 'project/:id',
        component: function component() {
            return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1185));
        },
        name: 'project',
        meta: {
            title: '项目更新',
            isBackend: false,
            mustAuth: true,
            hiddenToolbar: false,
            showNav: true,
            hidden: true,
            index: 7
        }
    }, {
        path: 'performance',
        component: function component() {
            return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1204));
        },
        name: 'project',
        meta: {
            title: '项目绩效看板',
            isBackend: false,
            mustAuth: true,
            hiddenToolbar: false,
            showNav: true,
            hidden: true,
            index: 8
        }
    }]
}, {
    path: '/admin/login',
    component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1198));
    },
    name: 'admin_login',
    meta: {
        title: '系统登陆',
        isBackend: true,
        mustAuth: false
    },
    hidden: true,
    index: 0
}, {
    path: '/admin',
    component: Backend,
    name: 'admin',
    meta: {
        title: '基本配置',
        isBackend: true,
        mustAuth: true
    },
    iconCls: 'el-icon-setting',
    index: 0,
    redirect: '/admin/employee',
    children: [{
        path: 'employee',
        name: 'employee',
        component: function component() {
            return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1195));
        },
        meta: {
            title: '员工信息管理',
            isBackend: true,
            mustAuth: true
        },
        index: 1
    }, {
        path: 'customer',
        name: 'customer',
        component: function component() {
            return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1190));
        },
        meta: {
            title: '客户信息管理',
            isBackend: true,
            mustAuth: true
        },
        index: 2
    }, {
        path: 'elc',
        name: 'elc',
        component: function component() {
            return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1192));
        },
        meta: {
            title: '员工级别配置',
            isBackend: true,
            mustAuth: true
        },
        index: 3
    }, {
        path: 'infoManage',
        name: 'infoManage',
        component: function component() {
            return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1191));
        },
        meta: {
            title: '部门信息管理',
            isBackend: true,
            mustAuth: true
        },
        index: 4
    }, {
        path: 'contractManage',
        name: 'contractManage',
        component: function component() {
            return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1189));
        },
        meta: {
            title: '合同信息管理',
            isBackend: true,
            mustAuth: true
        },
        index: 5
    }, {
        path: 'holidayConfig',
        name: 'holidayConfig',
        component: function component() {
            return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1201));
        },
        meta: {
            title: '节假日配置',
            isBackend: true,
            mustAuth: true
        },
        index: 6
    }]
}, {
    path: '/admin',
    component: Backend,
    name: "admin",
    meta: {
        title: '项目管控',
        isBackend: true,
        mustAuth: true
    },
    iconCls: "el-icon-s-operation",
    index: 1,
    redirect: '/admin/project',
    children: [{
        path: 'project',
        name: 'project',
        component: function component() {
            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1200));
        },
        meta: {
            title: '项目信息管理',
            isBackend: true,
            mustAuth: true
        },
        index: 1
    }, {
        path: 'progress',
        name: 'progress',
        component: function component() {
            return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1199));
        },
        meta: {
            title: '项目执行管理',
            isBackend: true,
            mustAuth: true
        },
        index: 2
    }, {
        path: 'consume',
        name: 'consume',
        component: function component() {
            return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1194));
        },
        meta: {
            title: '工时审批管理',
            isBackend: true,
            mustAuth: true
        },
        index: 3
    }]
}, {
    path: '/admin',
    component: Backend,
    name: "admin",
    meta: {
        title: "报表查看",
        isBackend: true,
        mustAuth: true
    },
    iconCls: 'el-icon-document',
    index: 2,
    children: [{
        path: 'availability',
        name: 'availability',
        component: function component() {
            return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1193));
        },
        meta: {
            title: '人员绩效情况',
            isBackend: true,
            mustAuth: true
        },
        index: 1
    }, {
        path: 'report',
        name: 'report',
        component: function component() {
            return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1197));
        },
        meta: {
            title: '部门绩效情况',
            isBackend: true,
            mustAuth: true
        },
        index: 2
    }, {
        path: 'angle',
        name: 'angle',
        component: function component() {
            return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1188));
        },
        meta: {
            title: "项目执行情况",
            isBackend: true,
            mustAuth: true
        },
        index: 3
    }, {
        path: 'fill',
        name: 'fill',
        component: function component() {
            return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1196));
        },
        meta: {
            title: '人员填写情况',
            isBackend: true,
            mustAuth: true
        },
        index: 4
    }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

var router = new _vueRouter2.default({
    routes: routes
});

exports.default = router;

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(77);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(192);

var _axios2 = _interopRequireDefault(_axios);

var _auth = __webpack_require__(279);

var _index = __webpack_require__(324);

var _index2 = _interopRequireDefault(_index);

var _http_stop = __webpack_require__(750);

var _elementUi = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = _axios2.default.create({
    baseURL: "//pms.yechtech.com/api/",
    timeout: 40000 });

service.defaults.headers.post["Content-Type"] = 'text/plain';

service.interceptors.request.use(function (config) {
    (0, _http_stop.removePendingRequest)(config);

    (0, _http_stop.addPendingRequest)(config);
    if ((0, _auth.getToken)()) {
        config.headers.token = (0, _auth.getToken)();
    }
    return config;
}, function (error) {
    console.log((0, _stringify2.default)(error));
    _promise2.default.reject(error);
});

service.interceptors.response.use(function (response) {
    (0, _http_stop.removePendingRequest)(response.config);
    if (response && response.data) {
        switch (response.data.code) {
            case 401:
                (0, _auth.removeToken)();
                defaultUnLoginRedirect();
                break;
            case 500:
                if (response.data && response.data.detail) {
                    console.log(response.data.detail);
                }
                break;
        }
    }
    return response;
}, function (error) {
    if (error && error.response) {
        switch (error.response.status) {
            case 401:
                (0, _auth.removeToken)();
                defaultUnLoginRedirect();
                break;
            case 500:
                if (error.response.data && error.response.data.detail) {
                    console.log(error.response.data.detail);
                }

                return _promise2.default.resolve(error.response);
        }
    }
    return _promise2.default.reject(error.response);
});

function defaultUnLoginRedirect() {
    if (_index2.default.currentRoute.meta && _index2.default.currentRoute.meta.isBackend) {
        _index2.default.replace({
            path: '/admin/login', query: { redirect: _index2.default.currentRoute.fullPath }
        });
    } else {
        _index2.default.replace({ path: '/login', query: { redirect: _index2.default.currentRoute.fullPath } });
    }
}

function defaultLoginRedirect() {
    if (_index2.default.currentRoute.meta && _index2.default.currentRoute.meta.isAdmin) {
        _index2.default.replace({
            path: '/admin//customer'
        });
    } else {
        _index2.default.replace({ path: '/epmc' });
    }
}

exports.default = service;

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVersionFromServer = undefined;

var _regenerator = __webpack_require__(195);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(214);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__(192);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var staticPrefix = __webpack_require__.p || '/';

var versionUrl = staticPrefix + 'static/version.json';

var getVersionFromServer = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    var response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _axios2.default.get(versionUrl);

          case 3:
            response = _context.sent;
            return _context.abrupt('return', response.data.version);

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);
            throw _context.t0;

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 7]]);
  }));

  return function getVersionFromServer() {
    return _ref.apply(this, arguments);
  };
}();

exports.getVersionFromServer = getVersionFromServer;

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__(324);

var _index2 = _interopRequireDefault(_index);

var _nprogress = __webpack_require__(193);

var _nprogress2 = _interopRequireDefault(_nprogress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_index2.default.beforeEach(function (to, from, next) {
    _nprogress2.default.start();
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    var isBackend = to.meta.isBackend;
    if (to.matched.some(function (record) {
        return record.meta.mustAuth;
    })) {
        var token = localStorage.getItem('token');
        if (isBackend) {
            if (token) {
                next();
            } else {
                _nprogress2.default.done();
                next({ path: '/admin/login' });
            }
        } else {
            if (token) {
                next();
            } else {
                _nprogress2.default.done();
                next({ path: '/login' });
            }
        }
    } else {
        next();
    }
});

_index2.default.afterEach(function (transition) {
    _nprogress2.default.done();
});

exports.default = _index2.default;

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(190);

var _vuex2 = _interopRequireDefault(_vuex);

var _employee = __webpack_require__(755);

var _employee2 = _interopRequireDefault(_employee);

var _holidayConfig = __webpack_require__(757);

var _holidayConfig2 = _interopRequireDefault(_holidayConfig);

var _project = __webpack_require__(759);

var _project2 = _interopRequireDefault(_project);

var _sysAdmin = __webpack_require__(762);

var _sysAdmin2 = _interopRequireDefault(_sysAdmin);

var _customer = __webpack_require__(753);

var _customer2 = _interopRequireDefault(_customer);

var _wechat = __webpack_require__(763);

var _wechat2 = _interopRequireDefault(_wechat);

var _department = __webpack_require__(754);

var _department2 = _interopRequireDefault(_department);

var _report = __webpack_require__(761);

var _report2 = _interopRequireDefault(_report);

var _contract = __webpack_require__(752);

var _contract2 = _interopRequireDefault(_contract);

var _workHours = __webpack_require__(764);

var _workHours2 = _interopRequireDefault(_workHours);

var _mind = __webpack_require__(758);

var _mind2 = _interopRequireDefault(_mind);

var _eteamChance = __webpack_require__(756);

var _eteamChance2 = _interopRequireDefault(_eteamChance);

var _projectPerformance = __webpack_require__(760);

var _projectPerformance2 = _interopRequireDefault(_projectPerformance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
    modules: {
        sysAdmin: _sysAdmin2.default,
        employee: _employee2.default,
        customer: _customer2.default,
        holidayConfig: _holidayConfig2.default,
        project: _project2.default,
        weChat: _wechat2.default,
        department: _department2.default,
        report: _report2.default,
        contract: _contract2.default,
        workHours: _workHours2.default,
        mindInfo: _mind2.default,
        eteamChance: _eteamChance2.default,
        projectPerformance: _projectPerformance2.default
    }
});
exports.default = store;

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1127)

var Component = __webpack_require__(605)(
  /* script */
  __webpack_require__(749),
  /* template */
  __webpack_require__(1143),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offsetModifier = exports.createPopper = undefined;

var _assign = __webpack_require__(280);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(46);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _set = __webpack_require__(768);

var _set2 = _interopRequireDefault(_set);

var _map = __webpack_require__(325);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}

function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;
  return (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)
  );
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}

function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}

function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}

var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var placements = [].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function order(modifiers) {
  var map = new _map2.default();
  var visited = new _set2.default();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn2) {
  var pending;
  return function () {
    if (!pending) {
      pending = new _promise2.default(function (resolve) {
        _promise2.default.resolve().then(function () {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat((0, _keys2.default)(modifier), VALID_PROPERTIES).filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case "name":
          if (typeof modifier.name !== "string") {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
          }
          break;
        case "enabled":
          if (typeof modifier.enabled !== "boolean") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
          }
          break;
        case "phase":
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(", "), '"' + String(modifier.phase) + '"'));
          }
          break;
        case "fn":
          if (typeof modifier.fn !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "effect":
          if (modifier.effect != null && typeof modifier.effect !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "requires":
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
          }
          break;
        case "requiresIfExists":
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
          }
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function (s) {
            return '"' + s + '"';
          }).join(", ") + '; but "' + key + '" was provided.');
      }
      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn2) {
  var identifiers = new _set2.default();
  return arr.filter(function (item) {
    var identifier = fn2(item);
    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function getBasePlacement(placement) {
  return placement.split("-")[0];
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? (0, _assign2.default)({}, existing, current, {
      options: (0, _assign2.default)({}, existing.options, current.options),
      data: (0, _assign2.default)({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return (0, _keys2.default)(merged).map(function (key) {
    return merged[key];
  });
}

function getVariation(placement) {
  return placement.split("-")[1];
}

function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
      default:
    }
  }
  return offsets;
}

var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: (0, _assign2.default)({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = (0, _assign2.default)({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        if (true) {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);
          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === "flip";
            });
            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
          }
          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft;
          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
        }
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
            reference2 = _state$elements.reference,
            popper2 = _state$elements.popper;
        if (!areValidElements(reference2, popper2)) {
          if (true) {
            console.error(INVALID_ELEMENT_ERROR);
          }
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference2, getOffsetParent(popper2), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper2)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = (0, _assign2.default)({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (true) {
            __debug_loops__ += 1;
            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
              fn2 = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      update: debounce(function () {
        return new _promise2.default(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      if (true) {
        console.error(INVALID_ELEMENT_ERROR);
      }
      return instance;
    }
    instance.setOptions(options).then(function (state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options2 = _ref3$options === void 0 ? {} : _ref3$options,
            effect3 = _ref3.effect;
        if (typeof effect3 === "function") {
          var cleanupFn = effect3({
            state: state,
            name: name,
            instance: instance,
            options: options2
          });
          var noopFn = function noopFn2() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners_default = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {},
  effect: effect,
  data: {}
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets_default = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};

var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = (0, _assign2.default)({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return (0, _assign2.default)({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return (0, _assign2.default)({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (true) {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || "";
    if (adaptive && ["transform", "top", "right", "bottom", "left"].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
    }
  }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = (0, _assign2.default)({}, state.styles.popper, mapToStyles((0, _assign2.default)({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = (0, _assign2.default)({}, state.styles.arrow, mapToStyles((0, _assign2.default)({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = (0, _assign2.default)({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles_default = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};

function applyStyles(_ref) {
  var state = _ref.state;
  (0, _keys2.default)(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    (0, _assign2.default)(element.style, style);
    (0, _keys2.default)(attributes).forEach(function (name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  (0, _assign2.default)(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    (0, _assign2.default)(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    (0, _keys2.default)(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = (0, _keys2.default)(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function (style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      (0, _assign2.default)(element.style, style);
      (0, _keys2.default)(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles_default = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect2,
  requires: ["computeStyles"]
};

var defaultModifiers = [eventListeners_default, popperOffsets_default, computeStyles_default, applyStyles_default];
var createPopper = popperGenerator({
  defaultModifiers: defaultModifiers
});

function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2((0, _assign2.default)({}, rects, {
    placement: placement
  })) : offset2,
      skidding = _ref[0],
      distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset_default = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
exports.createPopper = createPopper;
exports.offsetModifier = offset_default;

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'app',
    components: {},
    created: function created() {}
};

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removePendingRequest = exports.addPendingRequest = undefined;

var _map = __webpack_require__(325);

var _map2 = _interopRequireDefault(_map);

var _axios = __webpack_require__(192);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var apiWhitelist = [];
var pendingRequests = new _map2.default();

function getRequestKey(config) {
  var method = config.method,
      url = config.url,
      acRequestType = config.acRequestType;

  return [method, url, acRequestType || 'default'].join('&');
}

function addPendingRequest(config) {
  var requestKey = getRequestKey(config);
  config.cancelToken = config.cancelToken || new _axios2.default.CancelToken(function (cancel) {
    if (!pendingRequests.has(requestKey) && !apiWhitelist.some(function (item) {
      return requestKey.includes(item);
    })) {
      pendingRequests.set(requestKey, cancel);
    }
  });
}

function removePendingRequest(config) {
  var requestKey = getRequestKey(config);
  if (pendingRequests.has(requestKey) && !apiWhitelist.some(function (item) {
    return requestKey.includes(item);
  })) {
    var cancel = pendingRequests.get(requestKey);
    cancel('CancelToken');
    pendingRequests.delete(requestKey);
  }
}

exports.addPendingRequest = addPendingRequest;
exports.removePendingRequest = removePendingRequest;

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(195);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(214);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var checkVersion = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    var localVersion, serverVersion;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            localVersion = localStorage.getItem('appVersion');
            _context.next = 4;
            return (0, _http_version.getVersionFromServer)();

          case 4:
            serverVersion = _context.sent;


            if (!localVersion || localVersion !== serverVersion) {
              localStorage.setItem('appVersion', serverVersion);
            } else {}
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](0);

            console.error('Version check failed', _context.t0);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 8]]);
  }));

  return function checkVersion() {
    return _ref.apply(this, arguments);
  };
}();

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(601);

var _App2 = _interopRequireDefault(_App);

var _http_version = __webpack_require__(580);

var _echarts = __webpack_require__(583);

var echarts = _interopRequireWildcard(_echarts);

var _stringFormat = __webpack_require__(600);

var _stringFormat2 = _interopRequireDefault(_stringFormat);

__webpack_require__(584);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _elementUi = __webpack_require__(194);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(585);

var _vant = __webpack_require__(579);

var _vant2 = _interopRequireDefault(_vant);

__webpack_require__(588);

__webpack_require__(595);

__webpack_require__(592);

__webpack_require__(597);

__webpack_require__(596);

__webpack_require__(594);

__webpack_require__(593);

__webpack_require__(586);

__webpack_require__(589);

__webpack_require__(590);

__webpack_require__(591);

var _vxEasyui = __webpack_require__(604);

var _vxEasyui2 = _interopRequireDefault(_vxEasyui);

__webpack_require__(599);

var _nprogress = __webpack_require__(193);

var _nprogress2 = _interopRequireDefault(_nprogress);

__webpack_require__(587);

var _store = __webpack_require__(582);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(190);

var _vuex2 = _interopRequireDefault(_vuex);

var _router = __webpack_require__(581);

var _router2 = _interopRequireDefault(_router);

var _vuetify = __webpack_require__(602);

var _vuetify2 = _interopRequireDefault(_vuetify);

__webpack_require__(598);

var _colors = __webpack_require__(603);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.prototype.$echarts = echarts;

_stringFormat2.default.extend(String.prototype, {});

_vue2.default.prototype.$moment = _moment2.default;
_moment2.default.locale('zh-cn');
_vue2.default.prototype.$bus = new _vue2.default();

_vue2.default.use(_elementUi2.default);

_vue2.default.use(_vant2.default);

_vue2.default.use(_vxEasyui2.default);

_vue2.default.use(_nprogress2.default);
_nprogress2.default.configure({ showSpinner: false });

_vue2.default.use(_vuex2.default);

_vue2.default.use(_vuetify2.default, {
  theme: {
    primary: _colors2.default.red.darken1,
    secondary: _colors2.default.red.lighten4,
    accent: _colors2.default.indigo.base },
  icons: {
    iconfont: 'mdi' }
});

_vue2.default.directive('throttle', {
  bind: function bind(el, binding) {
    var throttleTime = binding.value;
    if (!throttleTime) {
      throttleTime = 2000;
    }
    var cbFun = void 0;
    el.addEventListener('click', function (event) {
      if (!cbFun) {
        cbFun = setTimeout(function () {
          cbFun = null;
        }, throttleTime);
      } else {
        event && event.stopImmediatePropagation();
      }
    }, true);
  }
});

new _vue2.default({
  el: '#app',
  template: '<App/>',
  router: _router2.default,
  store: _store2.default,
  components: { App: _App2.default },
  render: function render(h) {
    return h(_App2.default, {});
  }
}).$mount('#app');

checkVersion();

/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contract = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getContrachlist: function getContrachlist(_ref, params) {
            var commit = _ref.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'contract/page',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        eidtContrach: function eidtContrach(_ref2, params) {
            var commit = _ref2.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'contract',
                    method: 'put',
                    data: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        addContrach: function addContrach(_ref3, params) {
            var cmmmit = _ref3.cmmmit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'contract',
                    method: 'post',
                    data: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getAllCustomer: function getAllCustomer(_ref4) {
            var commit = _ref4.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'customer/all',
                    method: 'get'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getContrachAll: function getContrachAll(_ref5, params) {
            var commit = _ref5.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: "contract/all",
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getCollectInfo: function getCollectInfo(_ref6, params) {
            var commmit = _ref6.commmit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'collect/all',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        editCollectInfo: function editCollectInfo(_ref7, params) {
            var commit = _ref7.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: "collect",
                    method: 'put',
                    data: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(Error);
                });
            });
        },
        deleteContract: function deleteContract(_ref8, id) {
            var cmmmit = _ref8.cmmmit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'contract/' + id,
                    method: 'delete'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        }
    }
};
exports.default = contract;

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customer = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getCustomerWithPage: function getCustomerWithPage(_ref, params) {
            var commit = _ref.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'customer/page',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        createCustomer: function createCustomer(_ref2, customer) {
            var commit = _ref2.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'customer',
                    method: 'put',
                    data: customer
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        saveCustomer: function saveCustomer(_ref3, customer) {
            var cmmmit = _ref3.cmmmit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'customer',
                    method: 'post',
                    data: customer
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getAllCustomer: function getAllCustomer(_ref4) {
            var commit = _ref4.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'customer/all',
                    method: 'get'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        }
    }
};
exports.default = customer;

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var department = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getDeptInfo: function getDeptInfo(_ref, params) {
            var commit = _ref.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'dept/page',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        addDeptInfo: function addDeptInfo(_ref2, params) {
            var commit = _ref2.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'dept',
                    method: 'post',
                    data: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        editDeptInfo: function editDeptInfo(_ref3, params) {
            var commit = _ref3.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'dept',
                    method: 'put',
                    data: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getAllDeptInfo: function getAllDeptInfo(_ref4) {
            var commit = _ref4.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'dept/all',
                    method: 'get'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        }
    }
};

exports.default = department;

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(282);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

var _mutationTypes = __webpack_require__(213);

var _auth = __webpack_require__(279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var employee = {
    namespaced: true,
    state: {
        token: '',
        employeeInfo: null,
        isLogin: false
    },
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_LOGINUSER, function (state, _ref) {
        var yc_token = _ref.yc_token,
            employee = _ref.employee;

        state.employeeInfo = employee;
        state.isLogin = true;
        state.token = yc_token;

        (0, _auth.setToken)(yc_token);
        (0, _auth.setUserInfo)(employee);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.REMOVE_LOGINUSER, function (state) {
        state.employeeInfo = null;
        state.isLogin = false;
        state.token = '';

        (0, _auth.removeToken)();
        (0, _auth.removeUserInfo)();
    }), _mutations),
    actions: {
        login: function login(_ref2, _ref3) {
            var commit = _ref2.commit;
            var loginName = _ref3.loginName,
                password = _ref3.password,
                openId = _ref3.openId;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'login',
                    method: 'post',
                    data: {
                        loginName: loginName,
                        password: password,
                        openId: openId
                    }
                }).then(function (success) {
                    resolve(success);
                    if (success && success.data) {
                        commit(_mutationTypes.SET_LOGINUSER, { yc_token: success.data.token, employee: success.data.data });
                    }
                }, function (error) {
                    reject(error);
                });
            });
        },
        logout: function logout(_ref4) {
            var commit = _ref4.commit;

            commit(_mutationTypes.REMOVE_LOGINUSER);
            localStorage.clear();
        },
        changePwd: function changePwd(_ref5, newPwd) {
            var commit = _ref5.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'changePwd',
                    method: 'post',
                    data: { password: newPwd }
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getAllUsers: function getAllUsers(_ref6) {
            var commit = _ref6.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/all',
                    method: 'get'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getAllUsersValid: function getAllUsersValid(_ref7) {
            var commit = _ref7.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/validall',
                    method: 'get'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        postAllUsersCountUt: function postAllUsersCountUt(_ref8, params) {
            var commit = _ref8.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'v2/user/countUt',
                    method: 'post',
                    data: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        postAllUsersClearUt: function postAllUsersClearUt(_ref9, params) {
            var commit = _ref9.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'v2/user/clearUt',
                    method: 'post',
                    data: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getMonthOrYearUt: function getMonthOrYearUt(_ref10, params) {
            var commit = _ref10.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'v2/user/monthOrYearUt',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getHistoryNotCommitUt: function getHistoryNotCommitUt(_ref11, params) {
            var commit = _ref11.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'v2/user/historyNotCommitUt',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getUserWithPage: function getUserWithPage(_ref12, params) {
            var commit = _ref12.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/page',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        createUser: function createUser(_ref13, user) {
            var commit = _ref13.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user',
                    method: 'put',
                    data: user
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        saveUser: function saveUser(_ref14, user) {
            var commit = _ref14.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user',
                    method: 'post',
                    data: user
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getUserProject: function getUserProject(_ref15, loadHistory) {
            var commit = _ref15.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/project',
                    method: 'get',
                    params: { "loadHistory": loadHistory }
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getUserConsumeWithPage: function getUserConsumeWithPage(_ref16, params) {
            var commit = _ref16.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/consume/page',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        createConsume: function createConsume(_ref17, consume) {
            var commit = _ref17.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/consume',
                    method: 'put',
                    data: consume
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getConsume: function getConsume(_ref18, _ref19) {
            var commit = _ref18.commit;
            var date = _ref19.date,
                loadHistory = _ref19.loadHistory;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/consume',
                    method: 'get',
                    params: { date: date, loadHistory: loadHistory }
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        saveConsume: function saveConsume(_ref20, consume) {
            var commit = _ref20.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/consume',
                    method: 'post',
                    data: consume
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getUserConsumeGroupList: function getUserConsumeGroupList(_ref21, obj) {
            var commit = _ref21.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/consume/groupList',
                    method: 'get',
                    params: obj
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getAllLevelConfig: function getAllLevelConfig(_ref22) {
            var commit = _ref22.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/levelConfig/all',
                    method: 'get'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getLevelConfigWithPage: function getLevelConfigWithPage(_ref23, params) {
            var commit = _ref23.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/levelConfig/page',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        saveLevelConfig: function saveLevelConfig(_ref24, lc) {
            var commit = _ref24.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/levelConfig',
                    method: 'post',
                    data: lc
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        createLevelConfig: function createLevelConfig(_ref25, lc) {
            var commit = _ref25.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/levelConfig',
                    method: 'put',
                    data: lc
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getEmployeeAvailabilityList: function getEmployeeAvailabilityList(_ref26, params) {
            var commit = _ref26.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: "performance/user",
                    method: "get",
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        userOperate: function userOperate(_ref27, params) {
            var commit = _ref27.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/operate',
                    method: 'put',
                    data: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getRejectList: function getRejectList(_ref28, params) {
            var commit = _ref28.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/reject',
                    method: 'get',
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        deleteRejectList: function deleteRejectList(_ref29) {
            var cmmmit = _ref29.cmmmit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'user/reject',
                    method: 'delete'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getAllUsersValidV2: function getAllUsersValidV2(_ref30) {
            var commit = _ref30.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: '/v2/user/valid/all',
                    method: 'get'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        }
    }
};

exports.default = employee;

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eteamChance = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getEteamsChanceAll: function getEteamsChanceAll(_ref, _ref2) {
      var commit = _ref.commit;
      var params = _ref2.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: 'eteamsChance/all',
          method: 'get',
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getEteamsContractByEteamsId: function getEteamsContractByEteamsId(_ref3, _ref4) {
      var commit = _ref3.commit;
      var params = _ref4.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: 'eteamsContract',
          method: 'get',
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    }
  }
};
exports.default = eteamChance;

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var holidayConfig = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getAllConfig: function getAllConfig(_ref) {
            var commit = _ref.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'holidayConfig/all',
                    method: 'get'
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        },
        saveConfig: function saveConfig(_ref2, data) {
            var commit = _ref2.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'holidayConfig',
                    method: 'post',
                    data: data
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        }
    }
};
exports.default = holidayConfig;

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mindInfo = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getuserWxMainInfo: function getuserWxMainInfo(_ref, params) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: 'performance/userWxMainInfo',
          method: 'get',
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    }
  }
};
exports.default = mindInfo;

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var project = {
  namespaced: true,
  mutations: {},
  actions: {
    getAllProject: function getAllProject(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/all",
          method: "get"
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getlistWithPage: function getlistWithPage(_ref2, params) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/page",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    exportCurrent: function exportCurrent(_ref3, _ref4) {
      var commit = _ref3.commit;
      var params = _ref4.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/download",
          method: "get",
          params: params,
          responseType: "blob"
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getDeptList: function getDeptList(_ref5, _ref6) {
      var commit = _ref5.commit;
      var params = _ref6.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/dept",
          method: "get"
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getOtherData: function getOtherData(_ref7, _ref8) {
      var commit = _ref7.commit;
      var params = _ref8.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/otherCost",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    deleteOtherCost: function deleteOtherCost(_ref9, _ref10) {
      var commit = _ref9.commit;
      var params = _ref10.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/otherCost",
          method: "delete",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    addOtherCost: function addOtherCost(_ref11, _ref12) {
      var commit = _ref11.commit;
      var params = _ref12.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/otherCost",
          method: "post",
          data: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    updateOtherCost: function updateOtherCost(_ref13, _ref14) {
      var commit = _ref13.commit;
      var params = _ref14.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/otherCost",
          method: "put",
          data: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    createProject: function createProject(_ref15, proj) {
      var commit = _ref15.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project",
          method: "put",
          data: proj
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    saveProject: function saveProject(_ref16, proj) {
      var cmmmit = _ref16.cmmmit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project",
          method: "post",
          data: proj
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    deleteProject: function deleteProject(_ref17, id) {
      var cmmmit = _ref17.cmmmit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/" + id,
          method: "delete"
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    isDeleteUser: function isDeleteUser(_ref18, params) {
      var commit = _ref18.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/delete",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getUpdataList: function getUpdataList(_ref19, params) {
      var commit = _ref19.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/projectComments/all",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    progressrate: function progressrate(_ref20, params) {
      var commit = _ref20.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/progressrate",
          method: "post",
          data: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    progressratedel: function progressratedel(_ref21, _ref22) {
      var commit = _ref21.commit;
      var params = _ref22.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/progressratedel",
          method: "DELETE",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    addProjectComments: function addProjectComments(_ref23, params) {
      var commit = _ref23.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/addProjectComments",
          method: "post",
          data: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    deleteProjectComments: function deleteProjectComments(_ref24, id) {
      var commit = _ref24.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/deleteProjectComments/" + id,
          method: "delete"
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getProcessHistory: function getProcessHistory(_ref25, params) {
      var commit = _ref25.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/processHistory",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getProjectDetail: function getProjectDetail(_ref26, params) {
      var commit = _ref26.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/detail",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    saveProjectDetail: function saveProjectDetail(_ref27, params) {
      var commit = _ref27.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/update",
          method: "post",
          data: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getWxProjectList: function getWxProjectList(_ref28, params) {
      var commit = _ref28.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/list",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    checkProjectHours: function checkProjectHours(_ref29, params) {
      var commit = _ref29.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/hours",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    workHours: function workHours(_ref30, _ref31) {
      var commit = _ref30.commit;
      var params = _ref31.params,
          method = _ref31.method;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "projectworktime",
          method: method,
          data: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    queryRole: function queryRole(_ref32, _ref33) {
      var commit = _ref32.commit;
      var params = _ref33.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "worktimerole/list",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    queryProjectHours: function queryProjectHours(_ref34, _ref35) {
      var commit = _ref34.commit;
      var params = _ref35.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "projectworktime",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    queryProjectStartEndTime: function queryProjectStartEndTime(_ref36, _ref37) {
      var commit = _ref36.commit;
      var params = _ref37.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/utinfo/new",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    queryLevel: function queryLevel(_ref38, _ref39) {
      var commit = _ref38.commit;
      var params = _ref39.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "user/levelConfig/all",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getPreviewData: function getPreviewData(_ref40, _ref41) {
      var commit = _ref40.commit;
      var params = _ref41.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/process/preview",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    doFresh: function doFresh(_ref42, _ref43) {
      var commit = _ref42.commit;
      var params = _ref43.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "project/process/preview",
          method: "post",
          data: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    }
  }
};

exports.default = project;

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var project = {
  namespaced: true,
  mutations: {},
  actions: {
    getProjectList: function getProjectList(_ref, _ref2) {
      var commit = _ref.commit;
      var params = _ref2.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "pct/project/list",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getProjectBudget: function getProjectBudget(_ref3, _ref4) {
      var commit = _ref3.commit;
      var params = _ref4.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "pct/project/budget",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    reimbursementControl: function reimbursementControl(_ref5, _ref6) {
      var commit = _ref5.commit;
      var params = _ref6.params;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "pct/reimbursement/control",
          method: "get",
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    }
  }
};

exports.default = project;

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var report = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getDeptAchievements: function getDeptAchievements(_ref, params) {
            var commit = _ref.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: "performance/dept",
                    methods: "get",
                    params: params
                }).then(function (response) {
                    resolve(response);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getContractList: function getContractList(_ref2, params) {
            var commit = _ref2.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    methods: "get",
                    url: "contract/page",
                    params: params
                }).then(function (response) {
                    resolve(response);
                }, function (error) {
                    reject(error);
                });
            });
        },
        getUserUtilization: function getUserUtilization(_ref3, params) {
            var commit = _ref3.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    methods: "get",
                    url: "performance/utilization",
                    params: params
                }).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        }
    }
};

exports.default = report;

/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(282);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(77);

var _stringify2 = _interopRequireDefault(_stringify);

var _mutations;

var _mutationTypes = __webpack_require__(213);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sysAdmin = {
    namespaced: true,
    state: {
        drawer: false,
        token: '',
        adminInfo: null,
        collapsed: false,
        menu: '',
        snackbar: {
            show: false,
            type: '',
            text: ''
        }
    },
    mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SWITCH_COLLASPED, function (state) {
        state.collapsed = !state.collapsed;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.SWITCH_CURRENT_MENU, function (state, menu) {
        state.menu = menu;
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_ADMIN, function (state, _ref) {
        var adminInfo = _ref.adminInfo,
            token = _ref.token;

        state.adminInfo = adminInfo;
        state.token = token;

        localStorage.setItem('user-info', (0, _stringify2.default)(adminInfo));
        localStorage.setItem('token', token);
    }), (0, _defineProperty3.default)(_mutations, _mutationTypes.REMOVE_ADMIN, function (state) {
        state.adminInfo = null;
        state.token = '';

        localStorage.clear();
    }), (0, _defineProperty3.default)(_mutations, 'SET_SNACKBAR', function SET_SNACKBAR(state, option) {
        state.snackbar = option;
    }), (0, _defineProperty3.default)(_mutations, 'SET_DRAWER', function SET_DRAWER(state, value) {
        state.drawer = value;
    }), _mutations),
    actions: {
        switchCollasped: function switchCollasped(_ref2) {
            var commit = _ref2.commit;

            return commit(_mutationTypes.SWITCH_COLLASPED);
        },
        activeMenu: function activeMenu(_ref3, menu) {
            var commit = _ref3.commit;

            return commit(_mutationTypes.SWITCH_CURRENT_MENU, menu);
        },
        adminLogin: function adminLogin(_ref4, request) {
            var commit = _ref4.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'adminLogin',
                    method: 'post',
                    data: request
                }).then(function (success) {
                    resolve(success);
                    commit(_mutationTypes.SET_ADMIN, { adminInfo: success.data.data, token: success.data.token });
                }, function (error) {
                    reject(error);
                });
            });
        },
        adminLogout: function adminLogout(_ref5) {
            var commit = _ref5.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'adminLogout',
                    method: 'post'
                }).then(function (success) {
                    resolve(success);
                    commit(_mutationTypes.REMOVE_ADMIN);
                }, function (error) {
                    reject(error);
                });
            });
        }
    }
};

exports.default = sysAdmin;

/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(77);

var _stringify2 = _interopRequireDefault(_stringify);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

var _mutationTypes = __webpack_require__(213);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var weChat = {
    namespaced: true,
    state: {
        accessToken: '',

        pageAccessToken: '',

        openId: '',

        wechatUser: {}
    },
    getters: {
        currWeChatUser: function currWeChatUser(state) {
            return state.wechatUser;
        },
        CurrPageAccessToken: function CurrPageAccessToken(state) {

            return state.pageAccessToken;
        },
        currAccessToken: function currAccessToken(state) {
            return state.accessToken;
        },
        currOpenId: function currOpenId(state) {
            if (state.wechatUser) {
                return state.wechatUser.openId;
            }
            return '';
        }
    },
    mutations: {
        SET_CURR_WECHATUSER: function SET_CURR_WECHATUSER(state, user) {
            state.wechatUser = user;
            if (user) {
                localStorage.setItem("wechatUser", (0, _stringify2.default)(user));
            }
        },
        SET_CURR_ACCESSTOKEN: function SET_CURR_ACCESSTOKEN(state, accessToken) {
            state.accessToken = accessToken;
        },
        SET_CURR_PAGEACCESSTOKEN: function SET_CURR_PAGEACCESSTOKEN(state, pageAccessToken) {
            state.pageAccessToken = pageAccessToken;
        }
    },
    actions: {
        getPageAccessToken: function getPageAccessToken(_ref, code) {
            var commit = _ref.commit;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'weChat/pageAccessToken',
                    method: 'GET',
                    params: { code: code }
                }).then(function (response) {
                    resolve(response);
                    console.log(response);
                    if (response && response.data) {
                        commit('SET_CURR_PAGEACCESSTOKEN', response.data);
                        localStorage.setItem("openId", response.data.openId);
                    }
                }, function (error) {
                    reject(error);
                });
            });
        },
        getUserInfo: function getUserInfo(_ref2, _ref3) {
            var commit = _ref2.commit;
            var openId = _ref3.openId,
                code = _ref3.code;

            return new _promise2.default(function (resolve, reject) {
                return (0, _http2.default)({
                    url: 'weChat/userInfo',
                    method: 'POST',
                    data: { openId: openId, code: code }
                }).then(function (response) {
                    resolve(response);
                    console.log(response);
                    if (response && response.data.weChatUserInfo) {
                        commit('SET_LOGINUSER', { yc_token: response.data.token, employee: response.data.data });
                        commit('SET_CURR_WECHATUSER', response.data.weChatUserInfo);
                    }
                }, function (error) {
                    reject(error);
                });
            });
        }
    }
};

exports.default = weChat;

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(25);

var _promise2 = _interopRequireDefault(_promise);

var _http = __webpack_require__(48);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var workHours = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getWorkHoursInfo: function getWorkHoursInfo(_ref, params) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: 'user/approve',
          method: 'get',
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    getWorkHoursAll: function getWorkHoursAll(_ref2, params) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: 'user/approve/all',
          method: 'get',
          params: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    },
    commitWorkHours: function commitWorkHours(_ref3, params) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        return (0, _http2.default)({
          url: "user/approve",
          method: 'put',
          data: params
        }).then(function (success) {
          resolve(success);
        }, function (error) {
          reject(error);
        });
      });
    }
  }
};
exports.default = workHours;

/***/ })

},[751]);


// WEBPACK FOOTER //
// js/app.6a71caf8aaf85cd24466.1777536118929yechtech.js